/* import __COLOCATED_TEMPLATE__ from './set-conversation-data-attribute.hbs'; */
/* RESPONSIBLE TEAM: team-inbox-experience */
import templateOnlyComponent from '@ember/component/template-only';
import { type MacroAction } from 'embercom/objects/inbox/macro';

interface Signature {
  Args: { action: MacroAction };
}

const SetConversationDataAttribute = templateOnlyComponent<Signature>();
export default SetConversationDataAttribute;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::CommandK::UseMacro::Preview::SetConversationDataAttribute': typeof SetConversationDataAttribute;
    'inbox2/command-k/use-macro/preview/set-conversation-data-attribute': typeof SetConversationDataAttribute;
  }
}
